<template>
  <div class="animated fadeIn" style="min-height:900px;display:flex;
  flex-flow:column;height:100%;">
    <!-- Cancellations -->
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col>
          <b-card class="border-0">
            <div class="card-text">
              <div class="d-flex flex-row justify-content-start py-2 py-lg-2 py-md-2">
                <div class="text-dark mr-3"><i class="el-icon-success headericon"></i></div>
                <div class="h4 font-weight-bold text-dark">Elektronisk julekort</div>
              </div>
              <div class="pt-0 pr-1 pl-1 open-sans line-height-golden h5">
                Som noget helt nyt, kan vi hjælpe dig med at ønske dine kunder en glædelig jul. Udfyld blot dine kunders navn og e-mails herunder, og klik på "send elektronisk julekort".
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="pt-0 pr-3 pb-0 pl-3">
      <b-row no-gutters class="d-flex justify-content-start align-items-stretch bg-white h-100">
        <b-col sm="12" md="6" lg="6">
          <b-card class="border-0">
            <div class="card-text">
              <b-form @submit.stop.prevent="service_jule_action">
                <b-form-row>
                  <b-col>
                    <div class="h5 font-weight-bold headerfont mb-3 text-dark">Tilføj kundens navn og e-mail her</div>
                  </b-col>
                </b-form-row>
                <div class="py-2"></div>
                <b-form-row v-for="(customer, index) in customers" :key="index">
                  <b-col cols="5">
                    <b-form-group  label="Navn" >
                      <b-form-input  type="text"  v-model="customer.name" name="customers[][name]" required class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="5">
                    <b-form-group label="E-mail" >
                      <b-form-input  type="email"  v-model="customer.email" name="customers[][email]" required class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <div class="py-3"></div>
                    <b-button size="sm" class="rounded" @click="delCustomer(index)" variant="outline-danger"  v-if="index !== 0">
                      <span class="far fa-trash-alt"></span>
                    </b-button>
                    <b-button size="sm" class="rounded" @click="addCustomer()" variant="outline-success" v-if="index === 0">
                      <span class="el-icon-circle-plus"></span>
                    </b-button>
                  </b-col>
                </b-form-row>
                <b-form-row v-if="images.length !== 0">
                  <div>
                    <b-alert show variant="secondary" size="sm" class="sm">
                      Når du har valgt et billede kan du med fordel sende en test til din egen e-mail. Så er du sikker på at billedet passer i formatet.
                    </b-alert>
                    <b-btn v-b-toggle.collapse1 variant="primary" class="m-1">Vælg billede</b-btn>
                    <b-collapse id="collapse1">
                      <b-card>
                        <b-row>
                          <b-col lg="3" md="3" sm="12" v-for="image in images" :key="image.ImageId">
                            <!-- notifications in general -->
                            <label label :for="image.FileLocation" class="h6 font-weight-normal m-0">
                              <b-card :img-src="image.FileLocation" img-alt="Profil" img-top bg-variant="light" class="border-0">
                                <div class="d-flex justify-content-between justify-content-center">
                                  <div>
                                    <input type="radio" :id="image.FileLocation" :value="image.FileLocation" class="radion_select mr-1" v-model="imgPicked">
                                    Billede {{image.ImageOrder}}
                                  </div>
                                </div>
                              </b-card>
                            </label>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-collapse>
                  </div>
                </b-form-row>
                <b-form-row>
                  <b-col class="py-4 ">
                    <b-form-group label="" label-for="consentInput" >
                      <b-form-checkbox id="consentInput" v-model="consent" value="1"  unchecked-value="0">
                        <span class="text-secondary">Send mig en kopi af det afsendte julekort.</span>
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col sm="12" class="py-0 pr-5 ">
                    <div class="d-flex justify-content-center">
                      <b-btn size="lg" type="submit" class="rounded" variant="success">
                        <span class="mr2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"/></svg></span>
                        Send elektronisk julekort
                      </b-btn>
                    </div>
                  </b-col>
                </b-form-row>
              </b-form>
            </div>
          </b-card>
        </b-col>
        <b-col align-v="center" sm="12" md="6" lg="6">
          <b-card class="border-0" style="height:800px;">
            <div class="card-text">
              <div style="overflow:scroll !important; -webkit-overflow-scrolling: touch !important;">
                <b-embed type="iframe"  :src="url" aspect="1by1" style="-webkit-overflow-scrolling: touch;overflow-y: scroll;"  height="800px"></b-embed>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
    </b-container>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import loading from 'vue-full-loading'
import updatebitrixpackagepermission from '../../components/updatebitrixpackagepermission'
import Vue from 'vue'
export default {
  name: 'jule',
  components: {
    loading,
    Simplert,
    Vue,
    updatebitrixpackagepermission
  },
  data () {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: ''
      },
      customers: []
    }
  },
  watch: {
    imgPicked: function (newVal, oldVal) {
      this.url = 'https://www.kundematch.dk/newpartner/jule.php?salesPerson=' + this.salesPerson + '&levid=' + this.haaId + '&img=' + this.imgPicked
    }
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.images = res.resultImages
            if (this.images.length !== 0) {
              this.imgPicked = this.images[0].FileLocation
            }
            this.url = 'https://www.kundematch.dk/newpartner/jule.php?salesPerson=' + this.salesPerson + '&levid=' + this.haaId + '&img=' + this.imgPicked
          },
          response => {
            alert('error')
          }
        )
    },
    service_jule_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'service_jule_action', salesPerson: this.salesPerson, levid: this.haaId, customers: JSON.stringify(this.customers), imgPicked: this.imgPicked, bcc: this.consent}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: 'Dit elektroniske julekort er nu sendt til dine kunder.',
                type: 'success'
              }
              this.customers = []
              this.customers.push(Vue.util.extend({}, this.customer))
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    addCustomer () {
      this.customers.push(Vue.util.extend({}, this.customer))
    },
    delCustomer (index) {
      Vue.delete(this.customers, index)
    }
  },
  created () {
    this.customers.push(Vue.util.extend({}, this.customer))
    this.Reload()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// jule.vue?83308350